import React, { useState, useEffect, useCallback, useContext } from 'react';

import EmailLanguageSelector from '../../../components/common/EmailLanguageSelector';
import GiftCardAmount from './GiftCardAmount';
import NumberInput from '../../../components/widgets/NumberInput';
import Config from '../../../Config';
import { useCartContext } from '../../../context/CartContext';
import Modal from '../../../components/common/Modal';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from '../../../utils/DateUtils';
import DateTimePicker from '../../../components/common/DateTimePicker';
import moment from 'moment';
import { useGlobalContext } from '../../../context/GlobalContext';
import { CartContext } from '../../../context/CartContext';

import { cartAmountLimitAcheived, cartLimitAcheived } from '../../../utils/cartUtils';
import InfoContent from '../../../components/common/InfoContent';
import AccessibleContent from '../../../utils/AccessibleContent';

const professionalUser = {
  discount: null, // par exemple 10%
  limit_card: 5,   // exemple limite de cartes
  limit_amount: 200 // exemple limite d'achat
};

const Step1 = ({ step, store, selectedStore, lang, onStepChange, cart, selectedStoreCards }) => {
  const { t } = useTranslation();
  const { prepareTracking } = useGlobalContext();
  const handleLanguageChange = useCallback((selectedLang) => {
    setCardData(prev => ({
      ...prev,
      cardLanguage: store.languages.find(l => l.code === selectedLang.code),
      cardLanguageImg: `assets/images/flags/${selectedLang.code}.png`
    }));
  }, [store.languages]);
  //modal
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(""); // 'cart', 'delete', 'preview'
  const [itemToDelete] = useState(null);
  const [previewUrl, setPreviewUrl] = useState("");


  const isProSignboard = store.isProSignboard;
  const isAmexAvailable = store.allowAmex;
  const orderCardByAmountInCart = store.orderByAmountInCart ? store.orderByAmountInCart : false;
  const nbAddressLine = store.nbAddressLine || 3;
  const filteredCards = store.cards.filter(
    (card) => card.store === selectedStore || card.store === "both"
  );
  const {
    totalAmounts,
    cartItemsCountMax,
    cartAmountMax,
    addCard,
    deleteRequestCartItem
  } = useContext(CartContext);

  const [cardData, setCardData] = useState({
    selectedCard: null
  })
  const [destinationType, setDestinationType] = useState("email");
  const [selectedMessageIndex, setSelectedMessageIndex] = useState("");
  const [dateTimeMode, setDateTimeMode] = useState("now");
  const [quantity, setQuantity] = useState(1);
  const [useAmex, setUseAmex] = useState(false);
  const [infoField, setInfoField] = useState("");
  const [errors, setErrors] = useState({});

  const handleShowInfo = (field) => setInfoField(field);
  const handleHideInfo = () => setInfoField("");
  const [isFormValid, setIsFormValid] = useState(false);

  const filteredMessages =
    store.personalsMsgs && store.personalsMsgs.filter(
      msg => msg.store === selectedStore || msg.store === 'both'
    );
  const checkCartLimit = () => {
    return cartLimitAcheived({
      store,
      selectedStore,
      cart,
      cartItemsCountMax,
      qtyToAdd: quantity
    });
  };

  const checkAmountLimit = () => {
    const cardMontant = cardData.customMontant !== undefined ?
      cardData.customMontant :
      cardData.montant;

    return cartAmountLimitAcheived({
      store,
      totalAmounts,
      cardMontant,
      qty: quantity
    });
  };

  const handleMessageChange = (e) => {

    const index = e.target.value;
    setSelectedMessageIndex(index);
    if (index !== "") {
      const msg = filteredMessages[index];
      setCardData(prev => ({ ...prev, customMsg: msg.texts[lang] }));
    } else {
      setCardData(prev => ({ ...prev, customMsg: "" }));
    }
  };

  useEffect(() => {
    prepareTracking('home');
  }, [prepareTracking]);


  const [selectedCardId, setSelectedCardId] = useState(null);

  useEffect(() => {
    setCardData(prev => ({ ...prev, isSelfDestination: destinationType === "main" }));
  }, [destinationType]);
  useEffect(() => {
    checkFormValidity();
  }, [cardData, destinationType]);
  useEffect(() => {
    if (filteredCards.length > 0 && (!cardData.selectedCard )) {
      setSelectedCardId(filteredCards[0]?.id)
      setCardData(prev => ({
        ...prev,
        selectedCard: filteredCards[0]
      }));
    }
  }, [selectedStore]); 
  if (step !== 1) return null;
  const checkFormValidity = () => {
    // Vérification de base pour tous les champs obligatoires
    let valid = cardData.montant && cardData.montant > 0 &&
      cardData.desfirstname && cardData.desfirstname.trim() !== "" &&
      cardData.deslastname && cardData.deslastname.trim() !== "";

    // Vérification supplémentaire pour les emails si le type de destination est "email"
    if (destinationType === "email") {
      valid = valid && cardData.desemail &&
        cardData.desemail.trim() !== "" &&
        /\S+@\S+\.\S+/.test(cardData.desemail) &&
        cardData.desconfEmail === cardData.desemail;
    }

    // Vérification pour les adresses si le store est physique
    if (selectedStore === 'physical') {
      valid = valid && cardData.des_address_1 && cardData.des_city &&
        cardData.des_zip && cardData.des_country;
    }

    setIsFormValid(valid);
    return valid;
  };
  const validateForm = (isSubmitting = false) => {
    const newErrors = {};
    if (!cardData.montant || cardData.montant <= 0) {
      newErrors.montant = "Veuillez sélectionner un montant valide.";
    }
    else {
      const manualOffer = store.offers
        .filter(o => o !== null)
        .find(o => o.type === 'manual');
      if (manualOffer) {
        const num = Number(cardData.montant);

        if ((num < manualOffer.min) || (num > manualOffer.max)) {
          newErrors.montant = t("Cette carte n'est plus disponible pour le moment. Veuillez choisir un autre montant ou réessayer plus tard.");
        }
      }
    }
    if (checkCartLimit()) {
      newErrors.cartLimit = t("Vous avez atteint la limite maximale d'articles dans votre panier.");
    }

    // Vérification des limites de montant
    if (checkAmountLimit()) {
      newErrors.cartAmountLimit = t("Vous avez atteint la limite maximale de montant pour votre panier.");
    }

    // Seulement valider les champs obligatoires lors de la soumission
    if (isSubmitting) {
      if (!cardData.desfirstname || cardData.desfirstname.trim() === "") {
        newErrors.desfirstname = t("Veuillez saisir votre prénom.");
      }
      if (!cardData.deslastname || cardData.deslastname.trim() === "") {
        newErrors.deslastname = t("Veuillez saisir votre nom.");
      }
      if (destinationType === "email") {
        if (!cardData.desemail || cardData.desemail.trim() === "") {
          newErrors.desemail = t("Veuillez saisir un email valide.");
        } else if (!/\S+@\S+\.\S+/.test(cardData.desemail)) {
          newErrors.desemail = t("Veuillez saisir un email valide.");
        }
        if (cardData.desemail !== cardData.desconfEmail) {
          newErrors.desconfEmail = t("Les adresses email ne correspondent pas.");
        }
      }
      if (cardData.customMsg && cardData.customMsg.length > (store.physical_store?.message_length_limit || Config.app.max_msg_length)) {
        newErrors.customMsg = t("Votre message est trop long")
      }
    }

    // Ne pas mettre à jour les erreurs lors d'une validation partielle
    if (isSubmitting) {
      setErrors(newErrors);
    }
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (store.isProSignboard || validateForm(true)) {
      // Obtention de la date et heure actuelles si dateTimeMode est "now"
      const now = new Date();
      const currentDate = now.toISOString().split('T')[0];
      const currentTime = now.toTimeString().split(' ')[0];



      for (let i = 0; i < quantity; i++) {
        const newCard = {
          card: cardData.selectedCard?.src,
          signboardId: store.id,
          visualId: cardData.selectedCard?.id,
          amount: cardData.montant,
          message: cardData.customMsg,
          emailReceiver: cardData.desemail,
          firstNameReceiver: cardData.desfirstname,
          lastNameReceiver: cardData.deslastname,
          isSelfDestination: destinationType === 'main',
          // Pour sendDate, on envoie soit la date sélectionnée, soit la date actuelle
          sendDate: dateTimeMode === 'after'
            ? `${cardData.date} ${cardData.time}`
            : `${currentDate} ${currentTime}`,
          // Pour sendDateTmp, on envoie soit le timestamp de la date sélectionnée, soit le timestamp actuel
          sendDateTmp: dateTimeMode === 'after'
            ? new Date(`${cardData.date} ${cardData.time}`).getTime() / 1000
            : Math.floor(now.getTime() / 1000),
          cgv: true,
          receiveInfos: "0",
          qty: 1,
          discount: cardData.cardData,
          momentSend: dateTimeMode,
          cardLanguage: cardData.cardLanguage?.code || 'fr',
          isGettingInvoiceActivated: store.sending_invoice_activated === 2,
          isGettingLivstickVideo: false,
        };
        if (selectedStore === 'physical') {
          newCard.physical = {
            address_1: cardData.des_address_1,
            address_2: cardData.des_address_2,
            address_3: cardData.des_address_3,
            address_4: cardData.des_address_4,
            city: cardData.des_city,
            zip: cardData.des_zip,
            country: typeof cardData.des_country === 'string'
              ? cardData.des_country
              : cardData.des_country[lang],
            state: cardData.des_state
              ? getStateName(cardData.des_state)
              : null,
            state_code: cardData.des_state
              ? cardData.des_state.code
              : null
          };
        }
        addCard(newCard);
      }
      setModalType('cart');
      setShowModal(true);
    }
  };
  const handleAutreCarteModal = () => {
    setShowModal(false);
    // Reset du formulaire
    setCardData({});
    setSelectedCardId(filteredCards[0]?.id)
    setCardData(prev => ({
      ...prev,
      selectedCard: filteredCards[0]
    }));
    setDestinationType("email");
    setSelectedMessageIndex("");
    setDateTimeMode("now");
  };
  const getStateName = (state) => {
    if (!state?.names) return '';
    return (
      state.names[lang] ||
      state.names[store.default_language] ||
      state.names[Object.keys(state.names)[0]]
    ) + ` (${state.code})`;
  };

  const handleValiderAchat = () => {
    setShowModal(false);
    onStepChange(2);
  };

  const showModalDemo = () => {
    setModalType('preview');
    const templateUrl = store.template[lang];
    setPreviewUrl(templateUrl);
    setShowModal(true);
  };
  const handleSelectAmount = (amount) => {
    setCardData(prev => ({ ...prev, montant: amount }));
  };

  const FieldError = ({ error, id }) => {
    if (!error) return null;

    return (
      <div className="field-error" id={`error-${id}`} role="alert">
        <span className="error-icon" aria-hidden="true">⚠️</span>
        <span className="error-message">{error}</span>
      </div>
    );
  };

  return (
    <div>
      <form
        method="post"
        name="step1Form"
        className={`step1Form ${store.offers && store.offers[4] && store.offers[4].type === 'manual' ? 'haveManualAmount' : ''}`}
        onSubmit={handleSubmit}
        noValidate
      >

        {/* Partie Carte */}
        <section aria-labelledby="card-section-title">
          <div className="cardPart">
            <div className="cardSection">
              <div className="cardPreview">
                <h2 id="card-section-title" className="sr-only">
                  {t("Section de sélection de carte cadeau")}
                </h2>
                {selectedStoreCards.length > 0 && (
                  <img
                    src={cardData.selectedCard ? cardData.selectedCard.src : selectedStoreCards[0].src}
                    data-id={cardData.selectedCard ? cardData.selectedCard.id : selectedStoreCards[0].id}
                    alt="Gift card design"
                    fetchPriority="high"
                    loading="eager"
                    onError={(e) => { e.target.onerror = null; e.target.src = 'fallback-image.webp' }}
                  />
                )}
              </div>
            </div>
            <div className="cardInfoSection">
              <div className="cardInfoBox">
                <div className="topBox cardInfos" >
                  <h2 className="cardLabel mainColor">{t('Carte Cadeau')}</h2>
                </div>
                <div className="cardThumbnails">
                  {filteredCards.map((card) => {
                    const isSelected = card.id === selectedCardId;
                    return (

                      <div key={`card-container-${card.id}`}>
                        <button
                          style={{ borderWidth: 0 }}
                          type="button"
                          className={`cardThumbnailButton ${isSelected ? 'selected mainColor' : ''}`}
                          onClick={() => {
                            setSelectedCardId(card.id);
                            setCardData(prev => ({ ...prev, selectedCard: card }));
                          }}
                          aria-pressed={isSelected}
                          aria-label={`Sélectionner la carte ${card.name || card.id}`}
                        >
                          <img
                            src={card.src}
                            alt={card.name || `Carte ${card.id}`}
                            className={`cardThumbnail ${isSelected ? 'selected mainColor' : ''}`}
                          />
                        </button>
                      </div>
                    );
                  })}
                </div>
              </div>

              {selectedStore === 'physical' && cart.items && cart.items.length === 0 && (
                <div className="btnsArea alignCenter">
                  <a href="/home/digital" className="btn buyOther">
                    {t('Envoyer une carte digitale')}
                  </a>
                </div>
              )}


              {/*             {professionalUser && professionalUser.discount && (
              <div className="discount">
                {t("Votre remise de")} {professionalUser.discount}% {t("sera appliquée sur votre panier")}
              </div>
            )} */}


              {selectedStore === 'digital' && (
                <div className='bottomSection'>
                  <div className="btnsArea alignCenter">
                    <button
                      type="button"
                      className="btn buyOther"
                      onClick={showModalDemo}
                      aria-label={t('Carte cadeau de démonstration')}
                    >
                      {t('Carte cadeau de démonstration')}
                    </button>
                  </div>
                </div>
              )}

              {store.mentionLegale && store.mentionLegale[lang] && (
                <AccessibleContent
                  htmlContent={store.mentionLegale[lang]}
                  className="bottomSection2 mainColor"
                />
              )}
            </div>
          </div>
        </section>
        <main>
          {/* Partie Formulaire */}
          <div className="mainCol">
            <div className="whiteBox">
              <div className="stepBox">
                <div className="formBox">
                  {/* Titre de section */}
                  <div className="formField">
                    <div className="formControl countInputContainer">
                      {!isProSignboard && selectedStore === 'digital' && <h2 className="fieldsGroupHead" style={{ padding: 0 }}>{t("J’offre cette carte")}</h2>}
                      {!isProSignboard && selectedStore === 'physical' && <h2 className="fieldsGroupHead" style={{ padding: 0 }}>{t("J’offre cette carte physique")}</h2>}
                      {isProSignboard && (
                        <label>
                          {t("Je commande une carte : je la recevrais alors à l'adresse email fournie au service B2B.")}
                        </label>
                      )}
                    </div>
                  </div>

                  {/* Mode d'envoi pour le store digital (non Pro) */}
                  {!isProSignboard && selectedStore === 'digital' && (
                    <>
                      <div className="formControl blockOptions customCheckbox hasInfo">
                        <div className="optionItem checkboxRadio">
                          <input
                            type="checkbox"
                            disabled={professionalUser.discount}
                            name="emailDestination"
                            id="emailDestination"
                            checked={destinationType === 'email'}
                            onChange={() => setDestinationType('email')}
                          />
                          <label style={{paddingTop:4}} htmlFor="emailDestination" className="square">{t("par email au bénéficiaire")}</label>
                        </div>
                        <InfoContent
                          id="forSelfDestination"
                          infoField={infoField}
                          showInfo={handleShowInfo}
                          hideInfo={handleHideInfo}
                          infoText={t("Si vous souhaitez envoyer directement la carte cadeau par email au bénéficiaire, veuillez sélectionner ce choix.")}
                          context="step1_checkbox"
                          ariaLabelShow={t("Afficher les informations sur l'envoi par email")}
                          ariaLabelHide={t("Fermer les informations sur l'envoi par email")}
                        />
                      </div>
                      <div className="formControl blockOptions customCheckbox hasInfo">
                        <div className="optionItem checkboxRadio">
                          <input
                            type="checkbox"
                            disabled={professionalUser.discount}
                            name="selfDestination"
                            id="selfDestination"
                            checked={destinationType === 'main'}
                            onChange={() => setDestinationType('main')}
                          />
                          <label style={{paddingTop:4}} htmlFor="selfDestination" className="square">{t("en main propre")}</label>
                        </div>
                        <InfoContent
                          id="forEmailDestination"
                          infoField={infoField}
                          showInfo={handleShowInfo}
                          hideInfo={handleHideInfo}
                          infoText={t("Si vous souhaitez offrir la carte cadeau uniquement en main propre après l'avoir imprimée, veuillez sélectionner ce choix.")}
                          context="step1_checkbox"
                          ariaLabelShow={t("Afficher les informations sur la remise en main propre")}
                          ariaLabelHide={t("Fermer les informations sur la remise en main propre")}
                        />
                      </div>
                    </>
                  )}

                  {/* Option d'ajout d'une vidéo (non Pro) */}
                  {!isProSignboard && !cardData.isSelfDestination && store.video_enabled && (
                    <div className="formControl blockOptions customCheckbox hasInfo">
                      <div className="optionItem checkboxRadio" >
                        <input type="checkbox" name="videoEnabled" id="videoEnabled" />
                        <label htmlFor="videoEnabled" >{t("Ajouter une vidéo à votre carte")}</label>
                      </div>
                      <InfoContent
                        id="forVideo"
                        infoField={infoField}
                        showInfo={handleShowInfo}
                        hideInfo={handleHideInfo}
                        infoText={t("Sélectionnez ce choix pour joindre une vidéo à votre carte cadeau. Le lien et instructions vous seront fournis par mail après votre achat")}
                        context="step1_checkbox"
                        ariaLabelShow={t("Afficher les informations sur l'ajout d'une vidéo")}
                        ariaLabelHide={t("Fermer les informations sur l'ajout d'une vidéo")}
                      />
                    </div>
                  )}

                  {/* Message prédéfini */}
                  {store.personalsMsgs && store.personalsMsgs.length > 0 && (
                    <div className="formField" id="row_personalsMsgs">
                      <div className="formControl blockOptions">
                        <div className="optionItem">
                          <select
                            name="personalsMsgs"
                            id="personalsMsgs"
                            value={selectedMessageIndex}
                            onChange={handleMessageChange}
                          >
                            <option value="">{t("Message prédéfini")}</option>
                            {filteredMessages &&
                              filteredMessages.map((msg, index) => (
                                <option key={index} value={index}>
                                  {msg.texts[lang]}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Champ "Message personnalisé" (non affiché pour Pro) */}
                  {!isProSignboard && (
                    <div className="formField" id="row_customMsg">
                      <div className="formControl" style={{ display: 'inline-block' }}>
                        <h2 className="fieldsGroupHead" style={{ padding: 0 }}>{t("Message personnalisé")}</h2>

                        <textarea
                          className="textareainfo"
                          name="customMsg"
                          style={{ padding: "25px 0px" }}
                          id="customMsg"
                          rows="1"
                          maxLength="100"
                          aria-label={t("Renseignez un message personnalisé (facultatif)")}
                          cols="60"
                          placeholder={t("Renseignez un message personnalisé (facultatif)")}
                          value={cardData.customMsg || ""}
                          onChange={(e) =>
                            setCardData({ ...cardData, customMsg: e.target.value })
                          }
                        ></textarea>
                        <InfoContent
                          id="forMessage"
                          infoField={infoField}
                          showInfo={handleShowInfo}
                          hideInfo={handleHideInfo}
                          infoText={t("Votre message ne doit pas contenir de propos injurieux ou considérés comme sensibles (ex : origine raciale ou ethnique, opinions religieuses, données de santé ou relative à la vie sexuelle)")}
                          context="step1_textarea"
                          buttonClassName="textareainfospan"
                          contentClassName="textareainfospan"
                          ariaLabelShow={t("Afficher les informations sur le message personnalisé")}
                          ariaLabelHide={t("Fermer les informations sur le message personnalisé")}
                        />
                        <em className="limitCardMsg">
                          {cardData.customMsg ? cardData.customMsg.length : 0}/{store.physical_store?.message_length_limit || Config.app.max_msg_length}
                        </em>
                      </div>
                    </div>
                  )}

                  {/* Sélecteur de montant */}
                  <GiftCardAmount
                    offers={store.offers}
                    selectedStore={selectedStore}
                    onSelectAmount={handleSelectAmount}
                    selectedAmount={cardData.montant}
                    store={{ ...store, useAmex }}
                  />

                  {/* Bloc AMEX */}
                  {isAmexAvailable && (
                    <div className="cardAmexSection customCheckbox">
                      <div className="amexCheckbox">
                        <input
                          type="checkbox"
                          name="payment-amex"
                          id="paymentAmex"
                          onChange={(e) => setUseAmex(e.target.checked)}
                          aria-describedby={isAmexAvailable ? "amex-payment-info" : undefined}
                        />
                        <label htmlFor="paymentAmex">
                          <span>{t("Je désire régler mon achat avec ma carte American Express")}</span>
                          <img src="../../../assets/images/amex.jpg" className="amexLogo" alt={t("Logo American Express")} />
                        </label>
                      </div>
                      {cart.haveAmexCard && (
                        <InfoContent
                          id="forAmexPayment"
                          infoField={infoField}
                          showInfo={handleShowInfo}
                          hideInfo={handleHideInfo}
                          infoText={t("Une carte cadeau d’un montant réservé AMEX est présente dans le panier")}
                          context="step1_checkbox"
                          showButton={false} // Option pour ne pas afficher le bouton d'ouverture
                          ariaLabelShow={t("Afficher les informations sur le paiement AMEX")}
                          ariaLabelHide={t("Fermer les informations sur le paiement AMEX")}
                        />
                      )}
                    </div>
                  )}



                  {/* Section Destinataire (non affichée pour Pro) */}
                  {!isProSignboard && (
                    <div className="hasInfo">
                      <h2 className="fieldsGroupHead" style={{ padding: 0, textAlign: 'left', marginTop: 32 }}>
                        {t("Destinataire")}
                      </h2>
                      <InfoContent
                        id="forDestinataire"
                        infoField={infoField}
                        showInfo={handleShowInfo}
                        hideInfo={handleHideInfo}
                        context="step1_destinataire"
                        infoText={
                          <>
                            <span>{t("Si vous souhaitez offrir la carte cadeau uniquement en main propre, mettez votre adresse email personnelle en destinataire.")}</span>
                            <br />
                            <span>{t("A noter que dans tous les cas, vous recevrez une copie du mail contenant la carte cadeau.")}</span>
                          </>
                        }
                        buttonStyle={{ backgroundColor: "#E5E5E5", marginTop: -12 }}
                        contentStyle={{ top: '14px', marginRight: 1 }}
                        contentClassName="destinataire"
                        ariaLabelShow={t("Afficher les informations sur le destinataire")}
                        ariaLabelHide={t("Fermer les informations sur le destinataire")}
                      />
                    </div>
                  )}

                  {/* Champs de coordonnées */}
                  <div className="fieldsGroup">
                    {!isProSignboard && (
                      <>
                        <div className="formField" id="row_desfirstname">
                          <div className="formControl">
                            <input
                              type="text"
                              name="desfirstname"
                              id="desfirstname"
                              placeholder={t("Prénom") + "*"}
                              aria-label={t("Prénom")}
                              required
                              aria-required="true"
                              value={cardData.desfirstname || ""}
                              onChange={(e) =>
                                setCardData({ ...cardData, desfirstname: e.target.value })
                              }
                              className={errors.desfirstname ? 'error' : ''}
                              aria-invalid={errors.desfirstname ? 'true' : 'false'}
                              aria-describedby={errors.desfirstname ? 'error-desfirstname' : undefined}
                            />
                          </div>
                          {errors.desfirstname && <FieldError error={errors.desfirstname} id="desfirstname" />}
                        </div>
                        <div className="formField" id="row_deslastname">
                          <div className="formControl">
                            <input
                              type="text"
                              name="deslastname"
                              id="deslastname"
                              placeholder={t("Nom") + "*"}
                              aria-label={t("Nom")}
                              required
                              aria-required="true"
                              value={cardData.deslastname || ""}
                              onChange={(e) =>
                                setCardData({ ...cardData, deslastname: e.target.value })
                              }
                              className={errors.deslastname ? 'error' : ''}
                              aria-invalid={errors.deslastname ? 'true' : 'false'}
                              aria-describedby={errors.deslastname ? 'error-deslastname' : undefined}
                            />
                            {errors.deslastname && <FieldError error={errors.deslastname} id="deslastname" />}
                          </div>
                        </div>
                        {destinationType === "email" && (
                          <>
                            <div className="formField" id="row_desemail">
                              <div className="formControl hasInfo">
                                <input
                                  type="email"
                                  name="desemail"
                                  id="desemail"
                                  placeholder={t("Email") + "*"}
                                  aria-label={t("Email")}
                                  required
                                  aria-required="true"
                                  value={cardData.desemail || ""}
                                  onChange={(e) =>
                                    setCardData({ ...cardData, desemail: e.target.value })
                                  }
                                  className={errors.desemail ? 'error' : ''}
                                  aria-invalid={errors.desemail ? 'true' : 'false'}
                                  aria-describedby={errors.desemail ? 'error-desemail' : undefined}
                                />
                                <InfoContent
                                  id="forEmailReceiver"
                                  infoField={infoField}
                                  showInfo={handleShowInfo}
                                  hideInfo={handleHideInfo}

                                  infoText={
                                    <>
                                      <h3 className="typoMedium">{t("La carte cadeau sera envoyée par email")}</h3>
                                      <p>
                                        {t("Veuillez privilégier une adresse personnelle car les serveurs professionnels peuvent filtrer les informations commerciales")}
                                      </p>
                                    </>
                                  }
                                  buttonStyle={{ backgroundColor: "#E5E5E5", marginTop: -14 }}
                                  contentStyle={{  marginRight: 1 }}
                                  ariaLabelShow={t("Informations sur l'email")}
                                  ariaLabelHide={t("Fermer les informations")}
                                />
                              </div>
                              {errors.desemail && <FieldError error={errors.desemail} id="desemail" />}
                            </div>
                            <div className="formField" id="row_desconfEmail">
                              <div className="formControl">
                                <input
                                  type="email"
                                  name="desconfEmail"
                                  id="desconfEmail"
                                  required
                                  aria-required="true"
                                  placeholder={t("Email confirmation") + "*"}
                                  aria-label={t("Email confirmation")}
                                  value={cardData.desconfEmail || ""}
                                  onChange={(e) =>
                                    setCardData({ ...cardData, desconfEmail: e.target.value })
                                  }
                                  className={errors.desconfEmail ? 'error' : ''}
                                  aria-invalid={errors.desconfEmail ? 'true' : 'false'}
                                  aria-describedby={errors.desconfEmail ? 'error-desconfEmail' : undefined}
                                />
                                {errors.desconfEmail && <FieldError error={errors.desconfEmail} id="desconfEmail" />}
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    )}
                    {selectedStore === 'physical' && (
                      <>
                        <div className="formField" id="row_des_address_1">
                          <div className="formControl">
                            <input
                              type="text"
                              name="des_address_1"
                              id="des_address_1"
                              placeholder={t("Adresse ligne 1") + "*"}
                              aria-label={t("Adresse ligne 1")}
                              required
                              aria-required="true"
                              value={cardData.des_address_1 || ""}
                              onChange={(e) =>
                                setCardData({ ...cardData, des_address_1: e.target.value })
                              }
                              className={errors.des_address_1 ? 'error' : ''}
                            />
                          </div>
                        </div>
                        <div className="formField" id="row_des_address_2">
                          <div className="formControl">
                            <input
                              type="text"
                              name="des_address_2"
                              id="des_address_2"
                              placeholder={t("Complément adresse ligne 2")}
                              aria-label={t("Complément adresse ligne 2")}
                              value={cardData.des_address_2 || ""}
                              onChange={(e) =>
                                setCardData({ ...cardData, des_address_2: e.target.value })
                              }
                            />
                          </div>
                        </div>
                        {nbAddressLine >= 3 && (
                          <div className="formField" id="row_des_address_3">
                            <div className="formControl">
                              <input
                                type="text"
                                name="des_address_3"
                                id="des_address_3"
                                placeholder={t("Complément adresse ligne 3")}
                                aria-label={t("Complément adresse ligne 3")}
                                value={cardData.des_address_3 || ""}
                                onChange={(e) =>
                                  setCardData({ ...cardData, des_address_3: e.target.value })
                                }
                              />
                            </div>
                          </div>
                        )}
                        {nbAddressLine >= 4 && (
                          <div className="formField" id="row_des_address_4">
                            <div className="formControl">
                              <input
                                type="text"
                                name="des_address_4"
                                id="des_address_4"
                                placeholder={t("Complément adresse ligne 4")}
                                aria-label={t("Complément adresse ligne 4")}
                                value={cardData.des_address_4 || ""}
                                onChange={(e) =>
                                  setCardData({ ...cardData, des_address_4: e.target.value })
                                }
                              />
                            </div>
                          </div>
                        )}
                        <div className="formField" id="row_des_city">
                          <div className="formControl">
                            <input
                              type="text"
                              name="des_city"
                              id="des_city"
                              placeholder={t("Ville") + '*'}
                              aria-label={t("Ville")}
                              required
                              aria-required="true"
                              value={cardData.des_city || ""}
                              onChange={(e) =>
                                setCardData({ ...cardData, des_city: e.target.value })
                              }
                              className={errors.des_city ? 'error' : ''}
                            />
                          </div>
                        </div>
                        <div className="formField" id="row_des_zip">
                          <div className="formControl">
                            <input
                              type="text"
                              name="des_zip"
                              id="des_zip"
                              placeholder={t("Code postal") + "*"}
                              aria-label={t("Code postal")}
                              required
                              aria-required="true"
                              value={cardData.des_zip || ""}
                              onChange={(e) =>
                                setCardData({ ...cardData, des_zip: e.target.value })
                              }
                              className={errors.des_zip ? 'error' : ''}
                            />
                          </div>
                        </div>
                        <div className="formField" id="row_des_country">
                          <div className="formControl">
                            <select
                              name="des_country"
                              id="des_country"
                              value={cardData.des_country || ""}
                              onChange={(e) =>
                                setCardData({ ...cardData, des_country: e.target.value })
                              }
                            >
                              <option value="">{t("Pays") + '*'}</option>
                              {store.physical_store &&
                                store.physical_store.countries &&
                                store.physical_store.countries.map((country, index) => (
                                  <option key={index} value={country[lang]}>
                                    {country[lang]}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                      </>
                    )}
                    {store.languages && store.languages.length > 1 ?
                      <EmailLanguageSelector
                        options={store.languages}
                        displayFlag={store.display_language_flag}
                        defaultLanguage={store.default_language}
                        onLanguageChange={handleLanguageChange}
                      />
                      :
                      null}

                    {/* Sélecteur de date/heure (affiché uniquement pour le store digital et non Pro) */}
                    {selectedStore === 'digital' && !isProSignboard && store.sendLaterEnabled && (
                      <div className="formField">
                        <h3 className="block typoMedium  alignCenter" id="sending_date" style={{
                          display: 'block',
                          padding: '8px 0',
                          margin: '0',
                          fontSize: '14px',
                          lineHeight: '22px',
                          color: '#383838'
                        }}>
                          {t("Date d'envoi de la carte cadeau par email")} :
                    </h3>
                        <div className="formControl dateTimeLine" aria-labelledby="sending_date" >
                          <div className="grid p16">
                            <div className="cell6 alignCenter">
                              <a
                                role="button"
                                href="#"
                                tabIndex="0"
                                className={`dateMode typoMedium ${dateTimeMode === "now" ? "active" : ""}`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  setDateTimeMode("now");
                                  const currentDateTime = formatDateTime.syncDateTime('now', store);
                                  setCardData(prev => {
                                    const newData = {
                                      ...prev,
                                      ...currentDateTime
                                    };
                                    return newData;
                                  });
                                }}
                                role="button"
                                aria-pressed={dateTimeMode === "now"}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    e.target.click();
                                  }
                                }}
                              >
                                {t("Maintenant")}
                              </a>
                            </div>
                            <div className="cell6 alignCenter">
                              <a

                                role="button"
                                href="#"
                                tabIndex="0"
                                className={`dateMode typoMedium ${dateTimeMode === "after" ? "active" : ""}`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  setDateTimeMode("after");
                                  if (!cardData.datepicker) {
                                    const nextDateTime = formatDateTime.syncDateTime('after', store);
                                    setCardData(prev => {
                                      const newData = {
                                        ...prev,
                                        ...nextDateTime
                                      };
                                      return newData;
                                    });
                                  }
                                }}
                                role="button"
                                aria-pressed={dateTimeMode === "after"}
                                onKeyDown={(e) => {
                                  // Permettre l'activation avec la touche Entrée ou Espace
                                  if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    e.target.click();
                                  }
                                }}
                              >
                                {t("Plus tard")}
                              </a>
                            </div>
                          </div>
                          {dateTimeMode === "after" && (
                            <div className="grid p16">
                              <div className="cell6 datepickerBox">
                                <DateTimePicker
                                  value={cardData.datepicker || moment().format(store.format_date)}

                                  onChange={(newDate) => {

                                    const { date, datepicker } = formatDateTime.handleDateChange(newDate, store);
                                    setCardData(prev => {
                                      const newData = {
                                        ...prev,
                                        date,
                                        datepicker,
                                        sendDate: `${date} ${prev.time}`,
                                        sendDateTmp: Math.floor(new Date(`${date} ${prev.time}`).getTime() / 1000)
                                      };
                                      return newData;
                                    });
                                  }}
                                  format={store.format_date || 'DD/MM/YYYY'}
                                  locale={lang}
                                  isDate={true}
                                />
                              </div>
                              <div className="cell6 timepickerBox">
                                <DateTimePicker
                                  value={cardData.timepicker || moment().format('HH:00')}
                                  onChange={(newTime) => {
                                    const { time, timepicker } = formatDateTime.handleTimeChange(newTime, store);
                                    setCardData(prev => {
                                      const newData = {
                                        ...prev,
                                        time,
                                        timepicker,
                                        sendDate: `${prev.date} ${time}`,
                                        sendDateTmp: Math.floor(new Date(`${prev.date} ${time}`).getTime() / 1000)
                                      };
                                      return newData;
                                    });
                                  }}
                                  format="HH:mm"
                                  locale={lang}
                                  isDate={false}
                                  showHeader={false}
                                />
                              </div>
                            </div>
                          )}


                        </div>


                      </div>
                    )}

                    {/* Zone d'affichage quantité */}

                    {orderCardByAmountInCart && selectedStore === 'digital' && (
                      <div >
                        <h2 className="fieldsGroupHead" style={{ padding: 0, marginTop: 32 }}>{t("Quantité :")}</h2>
                        <NumberInput id="quantity" min={1} value={quantity} onChange={setQuantity} />
                      </div>
                    )}
                    <div className="formField">
                      <div className="bottom10">{t("Les champs marqués d'un astérisque (*) sont obligatoires")}</div>
                      {/* Zone d'affichage d'un seul message d'erreur */}
                      <div className="errorBox" role="alert" aria-live="polite">
                        {Object.keys(errors).length > 0 && (
                          <div className="error-summary">
                            <span className="error-icon" aria-hidden="true">⚠️</span>
                            <span className="error-title">{t("Veuillez corriger les erreurs suivantes :")}</span>
                            <ul>
                              {Object.entries(errors).map(([key, message]) => (
                                <li key={key}>{message}</li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>


                  </div>

                </div>

              </div>
              <div className="actionsRow labelMargin">
                <input
                  type="submit"
                  name="submit"
                  id="submit"
                  className="btn"
                  value={t("Acheter la carte")}
                  style={{
                    backgroundColor: isFormValid ? "" : "#EAE8E1",
                    color: isFormValid ? "" : "#4D4B47",
                    borderColor: isFormValid ? "" : "#fff",
                    maxWidth: "100%"
                  }}
                />
              </div>
            </div>

          </div>
        </main>
      </form>
      {showModal && (
        <div role="dialog" aria-modal="true" aria-labelledby="modal-title">
          <Modal
            modalType={modalType}
            onHideModal={() => {
              setShowModal(false);
              setModalType(null);
            }}
            onAutreCarteModal={handleAutreCarteModal}
            onValiderAchat={handleValiderAchat}
            itemToDelete={itemToDelete}
            onDeleteItem={(item) => {
              setShowModal(false);
              setModalType(null);
              deleteRequestCartItem(item)
            }}
            store={store}
            previewUrl={previewUrl}
          />
        </div>
      )}


    </div>
  );
};

export default Step1;
